module.exports = __webpack_public_path__ + "static/media/path_shape.2190e430.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Svg/path_shape.svg
// module id = 1365
// module chunks = 0